import { render, staticRenderFns } from "./presentationTable.vue?vue&type=template&id=f47c9280&scoped=true"
import script from "./presentationTable.vue?vue&type=script&lang=js"
export * from "./presentationTable.vue?vue&type=script&lang=js"
import style0 from "./presentationTable.vue?vue&type=style&index=0&id=f47c9280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47c9280",
  null
  
)

export default component.exports